module.exports = __webpack_public_path__ + "static/media/dumbbell.dbea2973.svg";